import React from 'react';
import { useFormState } from 'react-final-form';
import {
    linkedInResumeDownloadLink,
    trueFalseOptions,
} from '../../OnboardingConstants';
import GenericTextInputField from '../../../commons/form-fields/GenericTextInputField';
import GenericToggleButtonGroupField from '../../../commons/form-fields/GenericToggleButtonGroupField';
import GenericTextAreaInputField from '../../../commons/form-fields/GenericTextAreaInputField';
import HeaderAndError from '../../../commons/form-fields/HeaderAndError';
import { PreEmploymentInfoComponent } from './PreEmploymentInfoComponent';
import { LinkedinFileField } from './LinkedinFileField';
import CurrentAffiliationFormSection from './CurrentAffiliationFormSection';

export const ResumeInfoFormSection = () => {
    const { values } = useFormState();

    return (
        <div className="max-w-4xl mx-auto bg-white px-6 py-1 md:mt-3 md:mb-6 rounded shadow-md text-sm">
            <HeaderAndError label="Resume" />
            <div className="mb-4">
                <div className="w-full mb-2">
                    <label className="block text-gray-700 text-sm font-bold mb-1 md:mb-0 pr-4">
                        Upload LinkedIn Resume <span>(Optional)</span>{' '}
                    </label>
                </div>
                <div className="w-full">
                    <LinkedinFileField />
                    <span className="block mt-1 font-semibold text-blue-700 text-sm">
                        <p>
                            {' '}
                            Hint: Allow us to auto-fill the Biography and
                            Employment Information below by uploading your
                            LinkedIn Resume. Or you can go ahead and fill them
                            yourself. Only resumes downloaded from LinkedIn will
                            work.{' '}
                        </p>
                    </span>
                    <span className="text-blue-400 hover:text-blue-600 underline">
                        <a
                            href={linkedInResumeDownloadLink}
                            target="_blank"
                            rel="noreferrer"
                        >
                            How to download LinkedIn Resume?
                        </a>
                    </span>{' '}
                </div>
            </div>
            <div className="w-full mb-2">
                <label className="block text-gray-700 font-semibold mb-1 md:mb-0 py-4">
                    OR
                </label>
                <label className="block text-gray-700 text-sm font-bold mb-1 md:mb-0 pr-4 py-4">
                    Fill in the following details{' '}
                </label>
                <HeaderAndError
                    label="LinkedIn"
                    style="block text-xl text-teal-700 font-bold pl-1"
                />
                <GenericTextInputField
                    name="info.resume.linkedin"
                    label=""
                    type="text"
                />
                <HeaderAndError
                    label="Biography"
                    style="block text-xl text-teal-700 font-bold pl-1"
                />
                <GenericTextAreaInputField
                    name="info.resume.biography"
                    label=""
                />
                <HeaderAndError
                    label="Employment Information"
                    style="block text-xl text-teal-700 font-bold pl-1"
                />
                <label className="block text-sm text-teal-700 italic pl-1">
                    Please do not include board memberships. They are addressed
                    in a later section.
                </label>
                <GenericToggleButtonGroupField
                    name="info.resume.isCurrentlyEmployed"
                    inlineLabel={'Are you currently employed full time?'}
                    options={trueFalseOptions}
                    required
                />
                {values?.info?.resume?.isCurrentlyEmployed === false && (
                    <CurrentAffiliationFormSection />
                )}
                <PreEmploymentInfoComponent />
            </div>
        </div>
    );
};
